<template>
  <div v-if="showBlock"
       class="two-row__cell">
    <p class="row-one">{{ firstRow }}</p>
    <p class="row-two">{{ secondRow }}</p>
  </div>
</template>

<script>
  export default {
    computed: {
      propData() { return this.params?.data ? this.params?.data : this.data; },
      showBlock() { return true; },
      classes() { return this.propData?.classes; },
      firstRow() { return ''; },
      secondRow() { return ''; },
    }
  };
</script>
<style scoped>
.two-row__cell {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
}
</style>
